// React
import React, { cloneElement, isValidElement } from "react";
import PropTypes from "prop-types";
// Framework
import {
  makeStyles,
  ListItem,
  ListItemIcon,
  ListItemText,
  DelayedTooltip,
} from "ui/components";
import { Section } from "ui/section";
import { Typography } from "@material-ui/core";

////////////////////////////////////////////////////
/// Styles
////////////////////////////////////////////////////

const useStyles = makeStyles((theme) => ({
  selectable: {
    ...theme.typography.subtitle2,
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
}));

////////////////////////////////////////////////////
/// Component
////////////////////////////////////////////////////

const TileInfoItem = ({
  variant = "inline",
  context = "item",
  value,
  title,
  subtitle,
  icon,
  tooltip,
  dense,
  onClick,
}) => {
  // Style
  const classes = useStyles();
  // Render
  return (
    <Section context={context} value={value}>
      <ListItem dense={dense} alignItems="flex-start">
        {variant === "block" && (
          <ListItemText
            primary={
              <Typography variant="subtitle2" color="textPrimary">
                {title}
              </Typography>
            }
            secondary={
              <Typography variant="body2" color="textPrimary">
                {subtitle}
              </Typography>
            }
            onClick={onClick}
            classes={{
              primary: onClick && classes.selectable,
            }}
          />
        )}
        {variant === "inline" && (
          <>
            {icon && (
              <DelayedTooltip title={tooltip} placement="left">
                <ListItemIcon>
                  {isValidElement(icon) &&
                    cloneElement(icon, { fontSize: "small" })}
                </ListItemIcon>
              </DelayedTooltip>
            )}
            <ListItemText
              primary={title}
              secondary={subtitle}
              onClick={onClick}
              classes={{
                primary: onClick && classes.selectable,
              }}
            />
          </>
        )}
      </ListItem>
    </Section>
  );
};

TileInfoItem.propTypes = {
  variant: PropTypes.oneOf(["inline", "block"]),
  context: PropTypes.string,
  value: PropTypes.string,
  title: PropTypes.any,
  subtitle: PropTypes.any,
  icon: PropTypes.element,
  tooltip: PropTypes.string,
  dense: PropTypes.bool,
  onClick: PropTypes.func,
};

export default TileInfoItem;
